import { LoaderFunction, LoaderFunctionArgs } from "@remix-run/node";
import { json, Outlet } from "@remix-run/react";
import { OrderSource } from "~/entities/orderEntities";
import { ShouldRevalidateFunctionArgs } from "@remix-run/router/utils";

export const urlOrderSource: Record<string, OrderSource> = {
  "table-ordering": OrderSource.TABLE_ORDERING,
  online: OrderSource.ONLINE,
  // Catering is its own customer experience (separate menu, lead time, etc.),
  // mirroring how table-ordering carves out /table-ordering. Its order types
  // live under source=CATERING and the storefront renders the catering flow.
  catering: OrderSource.CATERING,
};

export const loader: LoaderFunction = async ({
  params,
}: LoaderFunctionArgs) => {
  if (!params.orderSource || !urlOrderSource[params.orderSource]) {
    throw json({ message: "Page not found" }, { status: 404 });
  }

  return null;
};

export const shouldRevalidate = ({
  actionResult,
  defaultShouldRevalidate,
}: ShouldRevalidateFunctionArgs) => {
  if (actionResult?.preventRevalidation) {
    return false;
  }
  return defaultShouldRevalidate;
};

const Page = () => {
  return <Outlet />;
};

export default Page;
